import { useRef, useEffect } from 'react';

const width = 900; // box width - spacing * 2, set in App.css - double for 4K res
const Waveform = ({audioContext}) => {
    const canvasRef = useRef(null);
    
    const draw = () => {
        audioContext.analyser.getByteFrequencyData(audioContext.dataArray);

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        
        switch (audioContext.waveform) {
            case 0: {
                const barWidth = (canvas.width / audioContext.bufferLength * 3);
                const render = (start, end) => {
                    let x = 0;
                    ctx.beginPath();
                    for (let i = start; i < end; i++) {
                        const barHeight = (canvas.height / 256) * audioContext.dataArray[i];
                        if (i === start) {
                            ctx.moveTo(x, (canvas.height - barHeight) * 0.95);
                        }
                        ctx.lineTo(x, (canvas.height - barHeight) * 0.95);
                        x += barWidth;
                    }
                    ctx.stroke();
                };
                ctx.strokeStyle = '#eee';
                render(0, audioContext.bufferLength/3);
                ctx.strokeStyle = '#ccc';
                render(audioContext.bufferLength/3, audioContext.bufferLength*2/3);
                ctx.strokeStyle = '#aaa';
                render(audioContext.bufferLength*2/3, audioContext.bufferLength);
            } break;
            case 1: {
                const barWidth = (canvas.width / audioContext.bufferLength);
                let x = 0;
                for (let i = 0; i < audioContext.bufferLength; i++) {
                    const value = audioContext.dataArray[i];
                    const barHeight = (canvas.height / 256) * value;
                    const palette = [value, value, value];//i % 256, value*0.9, value*0.5];
                    ctx.fillStyle = `rgb(${palette[0]},${palette[1]},${palette[2]})`;
                    ctx.fillRect(x, (canvas.height - barHeight) * 0.5, barWidth-1, barHeight);
                    x += barWidth;
                }
            } break;
            default: break;
        }

        requestAnimationFrame(draw);
    };

    useEffect(() => {
        if (audioContext) {
            console.log("Starting waveform visualizer");
            audioContext.waveform = 0;
            draw();
        }
    }, [audioContext]);

    const onCanvasClick = () => {
        if (audioContext) {
            audioContext.waveform = (audioContext.waveform + 1) % 2;
        }
    }

    return (
        <canvas className="waveform" ref={canvasRef} width={width} height="45" onClick={() => onCanvasClick()}/>
    );
};

export default Waveform;